import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SkeletonProdotti = () => {
    return (
        // Utilizziamo gli stessi identici colori dark scelti per le categorie
        <SkeletonTheme baseColor="#121824" highlightColor="#1A2234">
            <div className="flex flex-col gap-3.5 max-w-md mx-auto w-full">
                {[...Array(3)].map((_, i) => (
                    <div key={i} className="px-4 py-2 w-full">
                        {/* Contenitore specchiato sulla Card reale: orizzontale, rounded-2xl e padding identici */}
                        <div className="relative bg-[#121824]/40 border border-accent/20 rounded-2xl p-4 flex gap-4 items-start w-full opacity-70">
                            
                            {/* 🔘 Skeleton Immagine Circolare (w-20 sm:w-24) */}
                            <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-full overflow-hidden shrink-0 mt-0.5">
                                <Skeleton circle width="100%" height="100%" />
                            </div>

                            {/* 📝 Corpo Informativo allineato a sinistra */}
                            <div className="flex-1 flex flex-col justify-start min-w-0 pt-0.5">
                                {/* Titolo */}
                                <Skeleton width="55%" height={18} className="mb-2 rounded" />

                                {/* Ingredienti (Simuliamo due righe fluide di testo) */}
                                <div className="space-y-1 mb-3">
                                    <Skeleton width="90%" height={11} className="rounded" />
                                    <Skeleton width="75%" height={11} className="rounded" />
                                </div>

                                {/* Prezzo */}
                                <Skeleton width={50} height={16} className="rounded" />
                            </div>

                            {/* 🔗 Placeholder per la freccia di dettaglio (Floating in basso a destra) */}
                            <div className="absolute bottom-3 right-3 w-7 h-7 rounded-full overflow-hidden opacity-40">
                                <Skeleton circle width="100%" height="100%" />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </SkeletonTheme>
    );
};

export default SkeletonProdotti;